<template>
  <div>
    <div>
      <section-header :ressource="ressource"
                      :isExtended="true"
                      :dialog="dialog"
                      @closeDialog="closeDialog">
      </section-header>
    </div>
    <div>
      <v-combobox v-model="selectedConvention"
                  :items="conventions"
                  label="Convention à appliquer">
      </v-combobox>
      <v-combobox v-model="selectedEmploi"
                  :items="metiers"
                  :disabled="selectedConvention.key==0"
                  label="Métier conventionnels à appliquer">
      </v-combobox>
    </div>
    <div class="d-flex flex-row-reverse mt-4">
      <loader-button class="ms-2"
                     type='button'
                     :outlined="true"
                     :label="previewLabel"
                     :disabled="!canPreview"
                     :loading="loading"
                     @callback='preview'>
      </loader-button>
    </div>
  </div>
</template>

<script lang="ts">
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import {AppCustoms, FwkButtons, RessourceAppCustom, RessourceFwkButton} from '@/ressources/globalRessources';
import ContratTemplate from '@/generated/classes/ContratTemplate';
import Graph, {ConventionMetiers} from '@/generated/classes/Graph';
import Item from '@/framework/base/classes/Item';
import {defineComponent, type PropType} from "vue";

export default defineComponent({
  components: {
    LoaderButton,
    SectionHeader
  },
  props: {
    hideTitle: {
      type: Boolean
    },
    dialog: {
      type: Boolean
    },
    title: {
      type: String
    },
    contratTemplate: {
      type: Object as PropType<ContratTemplate>,
      required: true
    }
  },
  created() {
    Graph.listConventionMetiers().then((res) => {
      this.conventionMetiers = res;
    });
  },
  data() {
    const selectedConvention: Item = new Item(0, "");
    const selectedEmploi: Item = new Item(0, "");
    const conventionMetiers: ConventionMetiers[] = [];
    const cloneContratTemplate = ContratTemplate.fromJson(this.contratTemplate);

    return {
      applyButton: RessourceFwkButton(FwkButtons.APPLIQUER).label,
      conventionMetiers,
      selectedEmploi,
      selectedConvention,
      loading: false,
      cloneContratTemplate
    };
  },
  computed: {
    ressource() {
      return RessourceAppCustom(AppCustoms.CHOIX_PREVIEW);
    },
    previewLabel() {
      return RessourceFwkButton(FwkButtons.VISUALISER).label;
    },
    conventions(): Item[] {
      const res: Item[] = [];
      this.conventionMetiers.forEach((cm) => {
        res.push(new Item(cm.conventionId, cm.convention));
      })
      return res.sort((n1, n2) => parseInt(n1.title) - parseInt(n2.title));
    },
    metiers(): Item[] {
      const res: Item[] = [];
      this.conventionMetiers.forEach((cms) => {
        if (cms.conventionId == this.selectedConvention.key) {
          cms.metiers.forEach((m) => {
            res.push(new Item(m.metierId, m.metier));
          })
        }
      })
      return res.sort((n1, n2) => n1.title > n2.title ? 1 : -1);
    },
    canPreview(): boolean {
      return this.selectedConvention.key != 0 && this.selectedEmploi.key != 0;
    }
  },

  methods: {
    preview(): void {
      this.loading = true;
      this.cloneContratTemplate.conventionId = this.selectedConvention.key;
      this.cloneContratTemplate.metierId = this.selectedEmploi.key;
      ContratTemplate.preview(this.cloneContratTemplate).then(() => this.loading = false)
      this.$emit('closeDialog');
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
})

</script>
